import httpClient from './httpClient';

export default {
  getInfo: (apiKey, externalId) => httpClient.get(`/api/business/info/${apiKey}/${externalId}`),
  getIntegrationSettings: (apiKey, externalId) => httpClient.get(`/api/business/get/${apiKey}/${externalId}`),
  getChildIntegrations: (apiKey, externalId, postalCode, product) =>
    httpClient.get(
      `/api/business/marketplace-integration/${apiKey}/${externalId}/child-integration-info?product=${product}&postalCode=${postalCode}`
    ),
};
